import { registerComponent } from '../app'
import { CLOSE_MENU } from '../events'

const MenuShopButton = (scope, el) => {
	const props = {
		openClass: 'open'
	}
	scope.on(CLOSE_MENU, () => {
		el.classList.remove(props.openClass)
	})

	el.addEventListener('click', e => {
		e.preventDefault()
		e.stopPropagation()
		el.classList.contains(props.openClass)
			? el.classList.remove(props.openClass)
			: el.classList.add(props.openClass)
	})
}
registerComponent('menu-shop-button', MenuShopButton)
